<script setup lang="ts">
import VisibleColumnEditorComponent from 'frontend/columns/components/VisibleColumnEditorComponent.vue'
import { IColumnSortItems } from 'frontend/columns/types/IColumnSortItems'
import { DataModelType } from 'frontend/roles/enum/DataModelType'
import DropdownComponent from 'frontend/ui/components/DropdownComponent.vue'
import { computed } from 'vue'

interface Props {
  sortItems: IColumnSortItems
  dataModelType: DataModelType
  isMultiSortEnabled: boolean
  enabledColumnKeys: string[]
  pinnedColumns?: string[]
}
const props = defineProps<Props>()

interface Emits {
  (e: 'update:sortItems', value: IColumnSortItems): void
  (e: 'update:enabledColumnKeys', value: string[]): void
  (e: 'updatePinnedColumns', columnKey: string): void
}
const emit = defineEmits<Emits>()

const sortItemsModel = computed({
  get() {
    return props.sortItems
  },
  set(value) {
    emit('update:sortItems', value)
  },
})

const displayedColumnsModel = computed<string[]>({
  get() {
    return props.enabledColumnKeys
  },
  set(value: string[]) {
    emit('update:enabledColumnKeys', value)
  },
})
</script>

<template>
  <DropdownComponent placement="bottom-start" placement-strategy="flip">
    <div class="btn btn-tonal add-columns-button">
      <i class="mi-outlined mi-view-week" />
      <i class="mi-outlined mi-add" />
    </div>
    <template #dropdown="{ maxHeight }">
      <div class="dropdown-content">
        <div class="title">Add or remove columns</div>
        <VisibleColumnEditorComponent
          v-model:sort-items="sortItemsModel"
          v-model:enabled-column-keys="displayedColumnsModel"
          :data-model-type="dataModelType"
          :column-items-wrapper-style="{ maxHeight: `${maxHeight - 128}px` }"
          :is-multi-sort-enabled="isMultiSortEnabled"
          :pinnedColumns="pinnedColumns"
          @updatePinnedColumns="emit('updatePinnedColumns', $event)"
        />
        <!-- :available-columns="availableColumns" -->
      </div>
    </template>
  </DropdownComponent>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.add-columns-button {
  //width: 32px;
  height: 24px;
  padding: 0;
  min-height: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 4px;

  background: map.get(themeVariables.$specificColors, addTableColumnsButtonBackground);
  color: map.get(themeVariables.$colors, onSurface);

  &:hover {
    background: map.get(themeVariables.$colors, primary);
    color: map.get(themeVariables.$colors, onPrimary);
  }
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.dropdown-content {
  padding: 12px;
  display: grid;
  gap: 8px;
  min-width: 480px;
  min-height: 256px;
  grid-template-rows: auto 1fr;
}
</style>
